import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";

import "./style.scss";
import axios from "axios";

function Login() {

     const [showPassword, setShowPassword] = useState(false);

  const [validator] = useState(
    new SimpleReactValidator({
      className: "errorMessage",
    })
  );

  const [values, setValues] = useState({
    email: "",
    password: "",
  });

  const navigate = useNavigate()


  
  axios.defaults.withCredentials=true;

    const handleSubmit=(e)=>{
        e.preventDefault();

        axios.post("http://localhost:8081/admin-login",values)
        .then(res=>{
           if(res.data.Status==="Success"){
                navigate("/dashboard")
           }else{
                alert(res.data.Message);
           }
        }).catch(err=>{
            console.log(err)
        })

    }

  return (
    <>
      
       <Grid className="loginWrapper">
      <Grid className="loginForm">
        <h2>Sign In</h2>
        <p>Sign in to Faxian IT Admin Job Posting</p>

        <form onSubmit={handleSubmit}>

          <Grid container spacing={3}>
            {/* Email */}
            <Grid item xs={12}>
              <TextField
                className="inputOutline"
                fullWidth
                placeholder="E-mail or Username"
                variant="outlined"
                name="email"
                type="text"
                label="E-mail or Username"
                required
                InputLabelProps={{ shrink: true }}
               
                onChange={e=> setValues({...values,email:e.target.value})}

              />
            
            </Grid>

            {/* Password */}
            <Grid item xs={12}>
              <TextField
                className="inputOutline"
                fullWidth
                placeholder="Password"
              
                variant="outlined"
                name="password"
                type={showPassword ? "text" : "password"}
                label="Password"
                required
                InputLabelProps={{ shrink: true }}
    
                 onChange={e=> setValues({...values,password:e.target.value})}
              
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <i
                        className={showPassword ? "fa fa-eye-slash" : "fa fa-eye"}
                        style={{
                          cursor: "pointer",
                          fontSize: "20px",
                          color: "#555",
                        }}
                        onClick={() => setShowPassword(!showPassword)}
                      ></i>
                    </InputAdornment>
                  ),
                }}
              />
              
            </Grid>

            {/* Submit */}
            <Grid item xs={12}>
              <Grid className="formFooter">
                <Button
                  fullWidth
                  className="cBtnTheme"
                  type="submit"
                >
                  Login
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>

        <div className="shape-img">
          <i className="fi flaticon-honeycomb"></i>
        </div>
      </Grid>
    </Grid>



    </>
  )
}

export default Login
